import React, { useEffect, useState } from 'react'
import Knowledge from '../../../../../../API/Knowledge/knowledge'
import Loading from '../../../../../../Components/Loading/Loading'

const ModalFilter = ({ isOpen, onClose, author, document, tag, companyId }) => {
	const [results, setResults] = useState([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (!isOpen) return
		const fetchData = async () => {
			setLoading(true)
			try {
				const response = await Knowledge.searchDocuments(companyId, author, document, tag)
				setResults(response || [])
			} catch {
				setResults([])
			} finally {
				setLoading(false)
			}
		}
		fetchData()
	}, [isOpen, author, document, tag, companyId])

	if (!isOpen) return null

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50'>
			<div
				className='tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-6 tw-w-full tw-relative'
				style={{ maxWidth: 1200, maxHeight: '90vh', minHeight: 500, display: 'flex', flexDirection: 'column' }}
			>
				<div
					onClick={onClose}
					className='tw-absolute tw-top-4 tw-right-4 tw-text-gray-400 hover:tw-text-gray-700 tw-text-2xl tw-font-bold tw-z-10 tw-cursor-pointer'
					aria-label='Fechar'
					title='Fechar'
				>
					X
				</div>
				<h4 className='tw-font-bold tw-mb-4 tw-text-lg'>Documentos encontrados</h4>
				<div className='tw-mb-4 tw-text-sm tw-text-gray-600'>
					{author && (
						<span className='tw-mr-4'>
							Autor: <span className='tw-font-semibold'>{author}</span>
						</span>
					)}
					{document && (
						<span className='tw-mr-4'>
							Documento: <span className='tw-font-semibold'>{document}</span>
						</span>
					)}
					{tag && (
						<span>
							Tag: <span className='tw-font-semibold'>{tag.length} seleccionadas</span>
						</span>
					)}
				</div>
				<div className='tw-bg-white tw-rounded-b-xl tw-shadow tw-p-6 tw-flex-1' style={{ minHeight: 380, overflowY: 'auto', maxHeight: '60vh' }}>
					<div className='tw-grid tw-grid-cols-[60px_2fr_1.2fr_2fr] tw-font-bold tw-text-gray-600 tw-py-2 tw-px-4 tw-border-b'>
						<span className='tw-text-left'>#</span>
						<span className='tw-text-left'>Documento</span>
						<span className='tw-text-left'>Autor</span>
						<span className='tw-text-left'>Tags</span>
					</div>
					{loading ? (
						<Loading />
					) : results.length === 0 ? (
						<div className='tw-p-6 tw-text-gray-500'>Ningún documento encontrado.</div>
					) : (
						results.map((doc, idx) => (
							<div
								key={doc.id}
								className={`tw-grid tw-grid-cols-[60px_2fr_1.2fr_2fr] tw-items-center tw-py-3 tw-px-4 tw-rounded-xl ${
									idx % 2 === 0 ? 'tw-bg-gray-50' : 'tw-bg-white'
								}`}
							>
								<span className='tw-text-left tw-text-gray-400'>{idx + 1}</span>
								<a href={doc.url} target='_blank' rel='noopener noreferrer' className='tw-text-blue-600 hover:tw-underline' download>
									{doc.title}
								</a>
								<span className='tw-text-left'>{doc.authorName === 'Company' ? 'RRHH' : doc.authorName}</span>
								<div className='tw-flex tw-flex-wrap tw-gap-2 tw-mb-1 tw-overflow-y-auto'>
									{Array.isArray(doc.tags) &&
										doc.tags.map(tagObj => (
											<span key={tagObj.id} className='tw-px-3 tw-py-1 tw-rounded-full tw-text-xs tw-bg-purple-500 tw-text-white'>
												{tagObj.name}
											</span>
										))}
								</div>
							</div>
						))
					)}
				</div>
			</div>
		</div>
	)
}

export default ModalFilter
